import React from "react";
import "../styles/landing.css";
import Button from "./Button";

/**
 * Landing — hero section used on multiple pages.
 *
 * Behavior matrix:
 *  - trigger=true                  → button opens contact popup (no href used)
 *  - href present, no trigger      → button is an anchor to href
 *  - neither                       → plain button (props.onClick handler)
 *
 * Note: never nest <a> around a <button>. We render either an anchor OR a button.
 */
const Landing = ({
  title,
  subtitle,
  content,
  href,
  label,
  other,
  src,
  trigger,
  id,
}) => {
  return (
    <section id="home" className="container">
      <div className="landing">
        <header className="header-text">
          <h1>{title}</h1>
          {subtitle && <h1>{subtitle}</h1>}
          <p>{content}</p>
          <div className="hire-btn">
            {trigger ? (
              <Button label={label} trigger={true} id={id} />
            ) : href ? (
              <a
                href={href}
                className="landing-cta-link"
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
              >
                <Button label={label} id={id} />
              </a>
            ) : (
              <Button label={label} id={id} />
            )}
            {other && (
              <p>
                Looking for jobs instead?
                <a
                  className="link"
                  href="https://job.cloudare.in/jobs/Careers"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>Apply here</strong>
                </a>
              </p>
            )}
          </div>
        </header>
      </div>
      <div className="landing_image">
        <img className="landing-logo" src={src} alt={title || "Cloudare"} />
      </div>
    </section>
  );
};

export default Landing;
